export const GET_POSTS_REQUEST = "GET_POSTS_REQUEST";
export const GET_POSTS_SUCCESS = "GET_POSTS_SUCCESS";
export const GET_POSTS_FAIL = "GET_POSTS_FAIL";

export const GET_MORE_POSTS_REQUEST = "GET_MORE_POSTS_REQUEST";
export const GET_MORE_POSTS_SUCCESS = "GET_MORE_POSTS_SUCCESS";
export const GET_MORE_POSTS_FAIL = "GET_MORE_POSTS_FAIL";

export const CHANGE_INPUT_BLOG = "CHANGE_INPUT_FIELD_IN_BLOG"; 


export const BIGGEST_COMPANIES_SHOW_SWITCH_BUTTON = "BIGGEST_COMPANIES_SHOW_SWITCH_BUTTON";
   
      
     
    
    